import { render, staticRenderFns } from "./BookText.vue?vue&type=template&id=37eb91e1&"
import script from "./BookText.vue?vue&type=script&lang=js&"
export * from "./BookText.vue?vue&type=script&lang=js&"
import style0 from "./BookText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports